module.exports = __webpack_public_path__ + "img/noData.693813e2.png";